import Vue from "vue";
import Vuex from "vuex";
import defaultData from "@/data/mockData.json"
import { style } from "@/store/style.js"
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    control: {
      idioms: true,
      interests: true,
      otherData: true,
      references: false,
      projects: false,
    },
    basics: defaultData.basics,
    work: defaultData.work,
    volunteer: [],
    education: defaultData.education,
    awards: defaultData.awards,
    publications: defaultData.publications,
    languages: [
      {
        language: "English",
        fluency: "3",
      },
    ],
    skills: defaultData.skills,
    interests: defaultData.interests.map(i => i.name),
    references: "",//[]
    projects: "",//[]
    bioInfo: {
      nombre: "",
      titulo: "",
      bio:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates autem eaque nihil deserunt libero doloribus pariatu",
      image: require("@/assets/profile.svg"),
    },
    contactInfo: {
      email: "sansil32@gmail.com",
      direccion: "cebollati 1586",
      celular: "098 763344",
      nacimiento: "25 de febrero de 1990",
    },
    // skills: ['Vue js', 'React js', 'Node js', 'Microncontroladores', 'PLC'],
    idioms: [
      { name: "Inglés", level: 3 },
      { name: "Español", level: 5 }
    ],
    otherData: ["Libreta de conducir"],
  },
  getters: {
    courses: (state) => state.education.filter((e) => e.isCourse === true),
    education: (state) => state.education.filter((e) => e.isCourse === false || typeof (e.isCourse) === 'undefined')
  },
  mutations: {
    setBioInfo: (state, data) =>
      (state.bioInfo = { ...state.bioInfo, ...data }),
    setBasics: (state, data) => (state.basics = { ...state.basics, ...data }),
    setContactInfo: (state, data) =>
      (state.contactInfo = { ...state.contactInfo, ...data }),
    setIdioms: (state, data) => (state.idioms = data),
    setInterests: (state, data) => (state.interests = data),
    setSkills: (state, data) => (state.skills = data),
    setEducation: (state, data) => (state.education = data),
    setOtherData: (state, data) => (state.otherData = data),
    setWork: (state, data) => (state.work = data),
    setControl: (state, data) => (state.control = { ...state.control, ...data }),
    setProyects: (state, data) => (state.projects = data),
    setReferences: (state, data) => (state.references = data),
  },
  actions: {
    updateBioinfo ({ commit }, update) {
      commit("setBioInfo", update);
    },
    updateBasics ({ commit }, update) {
      commit("setBasics", update);
    },
    updateContactInfo ({ commit }, update) {
      commit("setContactInfo", update);
    },
    updateIdioms ({ commit }, update) {
      commit("setIdioms", update);
    },
    updateInterests ({ commit }, update) {
      commit("setInterests", update);
    },
    updateSkills ({ commit }, update) {
      commit("setSkills", update);
    },
    updateEducation ({ commit }, update) {
      commit("setEducation", update);
    },
    updateWork ({ commit }, update) {
      commit("setWork", update);
    },
    updateProyects ({ commit }, update) {
      commit("setProyects", update);
    },
    updateReferences ({ commit }, update) {
      commit("setReferences", update);
    },
    updateOtherData ({ commit }, update) {
      commit("setOtherData", update);
    },
    updateControl ({ commit }, update) {
      commit("setControl", update);
    }
  },
  modules: {
    style
  }
});
